const ViewUploadDataItem = ({ label, value, renderValue }) => {
  return (
    <div className="py-2 pr-2 sm:flex sm:items-start sm:gap-4">
      <p className="flex-1 text-sm text-gray-600">{label}</p>
      <p className="mt-0.5 flex-1 text-sm font-medium text-gray-900 sm:mt-0">
        {renderValue ? renderValue() : value}
      </p>
    </div>
  )
}

export default ViewUploadDataItem
